import { BitmapData, Point, Rectangle } from "../runtime";

/** a tile sheet and the canvas one of its cells is blitted into. */
export class SpriteLayer {
  /** may be swapped for another sheet with the same row layout. */
  sheet: BitmapData;
  readonly canvas: BitmapData;
  private readonly cellSize: number;
  private readonly rowLength: number;
  private readonly source: Rectangle;
  private readonly destination = new Point(0, 0);

  constructor(
    sheet: BitmapData,
    cellSize: number,
    canvasSize = cellSize,
    sheetWidth = sheet.width,
  ) {
    this.sheet = sheet;
    this.cellSize = cellSize;
    this.rowLength = (sheetWidth / cellSize) | 0;
    this.source = new Rectangle(0, 0, cellSize, cellSize);
    this.canvas = new BitmapData(canvasSize, canvasSize, true);
  }

  /** blits sheet cell `frame` onto the canvas. */
  draw(frame: number): void {
    this.source.x = ((frame % this.rowLength) | 0) * this.cellSize;
    this.source.y = ((frame / this.rowLength) | 0) * this.cellSize;
    this.canvas.copyPixels(this.sheet, this.source, this.destination);
  }
}

/** shared 0..9 sword-glow oscillator. */
export class SwordGlowPulse {
  private counter = 0;
  private rising = true;

  advance(): number {
    if (this.rising) {
      ++this.counter;
      if (this.counter === 9) {
        this.rising = false;
      }
    } else {
      --this.counter;
      if (this.counter <= 0) {
        this.rising = true;
      }
    }
    return this.counter;
  }

  startFalling(counter: number): void {
    this.counter = counter;
    this.rising = false;
  }
}
